export const map = {
  CASH_EQUITY: "4a7df351-634c-4d3d-91c0-8c89efc72564",
  	PROJECTED_RATE: "7d8f3ca5-3f5e-11e9-bf92-0242ac140002",
  AGGREGATE_EQUITY: "7d8f3e32-3f5e-11e9-bf92-0242ac140002",
  MAX_RECOURSE: "7d8f3eba-3f5e-11e9-bf92-0242ac140002",
  DEBT_MF_UNIT: "7d8f3f4c-3f5e-11e9-bf92-0242ac140002",
  DEBT_RSF: "7d8f3fcf-3f5e-11e9-bf92-0242ac140002",
  MF_UNITS: "7d8f4056-3f5e-11e9-bf92-0242ac140002",
  RSF: "7d8f40db-3f5e-11e9-bf92-0242ac140002",
  PREPAYMENT: "7d8f416d-3f5e-11e9-bf92-0242ac140002",
  PROPERTY_VALUE: "7d8f41f4-3f5e-11e9-bf92-0242ac140002",
  NOI: "7d8f427d-3f5e-11e9-bf92-0242ac140002",
  UNHEDGED_PV01: "7d8f42c4-3f5e-11e9-bf92-0242ac140002",
  HEDGED_PV01: "7d8f4357-3f5e-11e9-bf92-0242ac140002",
  FIXED_FLOATING_HEDGED_DEBT_PERCENT: "7d8f43ec-3f5e-11e9-bf92-0242ac140002",
  DSCR: "7d8f4483-3f5e-11e9-bf92-0242ac140002",
  DEBT_YIELD: "7d8f44c8-3f5e-11e9-bf92-0242ac140002",
  LTV: "7d8f4573-3f5e-11e9-bf92-0242ac140002",
  UNFUNDED_COMMITTED_DEBT: "7d8f45b7-3f5e-11e9-bf92-0242ac140002",
  TOTAL_OUTSTANDING_DEBT: "7d8f464c-3f5e-11e9-bf92-0242ac140002",
  WEIGHTED_AVERAGE_INTEREST_RATE: "7d8f469d-3f5e-11e9-bf92-0242ac140002",
  WEIGHTED_MATURITY: "7d8f46ef-3f5e-11e9-bf92-0242ac140002",
  DSCR_LENDER: "91014e52-c9a7-11e9-a4f9-00ff12c3b408",
  DSCR_ACTUAL: "91014e56-c9a7-11e9-a4f9-00ff12c3b408",
  NOI_ACTUAL: "b6b13504-c9a7-11e9-a4f9-00ff12c3b408",
  REFI_PROCEEDS: "bc486c27-8f9e-11ea-9df5-2c4d543da462",
  REFI_CASH_OUT: "bfbcbda4-8392-4620-82b9-a631db4057ae",
  ALL_IN_EFFECTIVE_RATE: "501c2df6-73d6-454b-b2a2-8691712c9edc"
};
export const list = Object.values(map);
export default {
  map,
  list
};
